import * as _ from "lodash";

import { Link } from "react-router-dom";
import React from "react";
import { NewButton } from "../../elements/ActionButtons/NewButton.jsx";
import SimpleSelect from "../../elements/CustomSelect/SimpleSelect";

const ReportsTypeSelect = ({
  value,
  showNewButton,
  intl,
  history,
  role,
  path
}) => {

  // console.log("role=", role);
  let options = [];

  if (role === "ADMIN") {
    options =
      [
        {
          value: "SALES",
          label: intl.formatMessage({ id: "ids_sales" })
        },
        {
          value: "RENTABILITY",
          label: intl.formatMessage({ id: "ids_rentability" })
        },
        {
          value: "EARNINGS",
          label: intl.formatMessage({ id: "ids_earnings" })
        },
        {
          value: "COSTS",
          label: intl.formatMessage({ id: "ids_costs" })
        },        
        {
          value: "TREASURY",
          label: intl.formatMessage({ id: "ids_treasury" })
        },
        {
          value: "TAXES",
          label: intl.formatMessage({ id: "ids_taxes" })
        },
        {
          value: "PERFORMANCE",
          label: intl.formatMessage({ id: "ids_performance" })
        }
      ];
  }
  else if (role === "COMPTABLE") {
    options =
      [
        {
          value: "SALES",
          label: intl.formatMessage({ id: "ids_sales" })
        },
        {
          value: "RENTABILITY",
          label: intl.formatMessage({ id: "ids_rentability" })
        },
        {
          value: "EARNINGS",
          label: intl.formatMessage({ id: "ids_earnings" })
        },
        {
          value: "COSTS",
          label: intl.formatMessage({ id: "ids_costs" })
        },
        {
          value: "TREASURY",
          label: intl.formatMessage({ id: "ids_treasury" })
        },
        {
          value: "TAXES",
          label: intl.formatMessage({ id: "ids_taxes" })
        },
        {
          value: "PERFORMANCE",
          label: intl.formatMessage({ id: "ids_performance" })
        }
      ];
  }
  else if (role === "COMMERCIAL") {
    options =
      [
        {
          value: "SALES",
          label: intl.formatMessage({ id: "ids_sales" })
        }
      ];
  }

  return (
    <div className="space-between full-width">
      <SimpleSelect
        name="salesType"
        value={value}
        onSelected={choice => {
          if (choice.value !== value) {
            switch (choice.value) {
              case "SALES":
                history.push("/reports/sales");
                break;

              case "EARNINGS":
                history.push("/reports/earnings");
                break;

              case "COSTS":
                history.push("/reports/costs");
                break;

              case "RENTABILITY":
                history.push("/reports/rentability");
                break;

              case "TREASURY":
                history.push("/reports/treasury");
                break;

              case "TAXES":
                history.push("/reports/taxes");
                break;

              case "PERFORMANCE":
                history.push("/reports/performance");
                break;
            }
          }
        }}
        options={options}
        clearable={false}
        centered={true}
      />
      {value && showNewButton === true ? (
        <NewButton
          style={{ marginTop: "1px" }}
          wd
          className="btn-fill"
          newRecordUrl={`${path}/new`}
        />
      ) : (
          <div />
        )
      }
    </div>
  );
};

export default ReportsTypeSelect;